<template>
  <relatorio-page :titulo="'Relatório Controle de Ocorrências'" :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="true" :fonteVariavel="true">
    <v-row class="fonte mb-2">
      <v-col cols="12" md="3"><strong>Beneficiário:</strong> {{ filtroDescricao.beneficiario }}</v-col>
      <v-col cols="12" md="3"><strong>Período:</strong> {{ Periodo() }}</v-col>
      <v-col cols="12" md="2"><strong>Tipo:</strong> {{ filtroDescricao.tipo }}</v-col>
      <v-col cols="12" md="2"><strong>Gravidade:</strong> {{ filtroDescricao.gravidade }}</v-col>
      <v-col cols="12" md="2"><strong>Projeto:</strong> {{ filtroDescricao.projeto }}</v-col>
    </v-row>

    <v-row v-if="itens.length > 0" class="fonte resumo-geral">
      <v-col cols="12" md="3"><strong>Total de ocorrências:</strong> {{ resumo.total }}</v-col>
      <v-col cols="12" md="3"><strong>Beneficiários:</strong> {{ resumo.quantidadeBeneficiarios }}</v-col>
      <v-col cols="12" md="2"><strong>Alta:</strong> {{ resumo.alta }}</v-col>
      <v-col cols="12" md="2"><strong>Média:</strong> {{ resumo.media }}</v-col>
      <v-col cols="12" md="2"><strong>Baixa:</strong> {{ resumo.baixa }}</v-col>
    </v-row>

    <v-row v-if="itens.length > 0">
      <v-col cols="12">
        <div v-for="grupo in gruposBeneficiario" :key="grupo.beneficiarioId" class="beneficiario-bloco fonte">
          <div class="beneficiario-titulo">
            <strong>{{ grupo.beneficiario }}</strong>
            <span class="ml-3">Matrícula: {{ grupo.matricula || '-' }}</span>
            <span class="ml-3">CPF/CNPJ: {{ grupo.cpfCnpj || '-' }}</span>
            <span class="ml-3">Ocorrências: {{ grupo.itens.length }}</span>
          </div>

          <v-simple-table dense class="py-2 text-caption">
            <template v-slot:default>
              <thead class="fonte" style="background-color: #4A70A8">
                <tr>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Código</th>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Data</th>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Projeto</th>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Tipo</th>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Gravidade</th>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Descrição</th>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Observações</th>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Responsável</th>
                  <th class="text-left fonte" style="font-size: 100%; color: white">Anexo</th>
                </tr>
              </thead>
              <tbody class="fonte">
                <tr v-for="(item, index) in grupo.itens" :key="item.id" :style="index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: white'">
                  <td style="font-size: 100%">{{ item.id }}</td>
                  <td style="font-size: 100%">{{ Data(item.dataOcorrencia) }}</td>
                  <td style="font-size: 100%">{{ item.projeto || 'Sem projeto' }}</td>
                  <td style="font-size: 100%">
                    <span class="cor-tipo" :style="`background-color:${item.ocorrenciaTipoCor || '#607D8B'}`"></span>
                    {{ item.ocorrenciaTipo }}
                  </td>
                  <td style="font-size: 100%">{{ item.gravidadeDescricao || '-' }}</td>
                  <td style="font-size: 100%">{{ item.descricao || '-' }}</td>
                  <td style="font-size: 100%">{{ item.observacoes || '-' }}</td>
                  <td style="font-size: 100%">{{ item.usuario || '-' }}</td>
                  <td style="font-size: 100%">{{ item.anexo || '-' }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
    </v-row>

    <v-row v-else-if="!overlay">
      <v-col cols="12">Nenhum registro foi encontrado.</v-col>
    </v-row>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </relatorio-page>
</template>

<script>
import { BeneficiarioOcorrenciaService } from '@/core/services/projetos';

export default {
  data: () => ({
    service: new BeneficiarioOcorrenciaService(),
    filter: {},
    itens: [],
    overlay: false
  }),
  computed: {
    gruposBeneficiario(){
      const grupos = [];

      this.itens.forEach(item => {
        let grupo = grupos.find(x => x.beneficiarioId == item.beneficiarioId);
        if(!grupo){
          grupo = {
            beneficiarioId: item.beneficiarioId,
            beneficiario: item.beneficiario,
            matricula: item.matricula,
            cpfCnpj: item.cpfCnpj,
            itens: []
          };
          grupos.push(grupo);
        }

        grupo.itens.push(item);
      });

      return grupos;
    },
    resumo(){
      const beneficiarios = [];
      this.itens.forEach(item => {
        if(!beneficiarios.includes(item.beneficiarioId))
          beneficiarios.push(item.beneficiarioId);
      });

      return {
        total: this.itens.length,
        quantidadeBeneficiarios: beneficiarios.length,
        alta: this.itens.filter(x => x.gravidade == 'A').length,
        media: this.itens.filter(x => x.gravidade == 'M').length,
        baixa: this.itens.filter(x => x.gravidade == 'B').length
      };
    },
    filtroDescricao(){
      const primeiro = this.itens.length > 0 ? this.itens[0] : {};
      return {
        beneficiario: primeiro.beneficiario && this.filter.beneficiarioId ? primeiro.beneficiario : 'Todos',
        tipo: primeiro.ocorrenciaTipo && this.filter.ocorrenciaTipoId ? primeiro.ocorrenciaTipo : (this.filter.ocorrenciaTipoId ? `Código ${this.filter.ocorrenciaTipoId}` : 'Todos'),
        gravidade: this.GravidadeNome(this.filter.gravidade) || 'Todas',
        projeto: primeiro.projeto && this.filter.projetoId ? primeiro.projeto : (this.filter.projetoId ? `Código ${this.filter.projetoId}` : 'Todos')
      };
    }
  },
  mounted(){
    this.filter = this.$route.query;
    this.Carregar();
  },
  methods: {
    Carregar(){
      this.overlay = true;
      this.service.Relatorio(this.filter).then(
        res => this.itens = res.data && res.data.itens ? res.data.itens : [],
        err => this.$swal('Aviso', err.response ? err.response.data : err.message, 'error')
      ).finally(() => this.overlay = false);
    },
    Periodo(){
      const inicio = this.filter.dataInicial ? this.Data(this.filter.dataInicial) : '';
      const fim = this.filter.dataFinal ? this.Data(this.filter.dataFinal) : '';

      if(inicio && fim) return `${inicio} a ${fim}`;
      if(inicio) return `A partir de ${inicio}`;
      if(fim) return `Até ${fim}`;
      return 'Todos';
    },
    Data(value){
      return value ? new Date(value).ddmmyyyy() : '-';
    },
    GravidadeNome(value){
      if(value == 'B') return 'Baixa';
      if(value == 'M') return 'Média';
      if(value == 'A') return 'Alta';
      return '';
    }
  }
}
</script>

<style>
.cor-tipo {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
}

.resumo-geral {
  background: #f1f3f5;
  padding: 6px 8px;
  margin-bottom: 8px;
}

.beneficiario-bloco {
  margin-bottom: 14px;
  break-inside: avoid;
}

.beneficiario-titulo {
  background: #e8eef5;
  padding: 6px 8px;
}
</style>
